import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { CompetitionResponse } from "~types/competition.ts";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties.ts";
import { InfinitySelect, type InfinitySelectOption } from "../InfinitySelect";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

const SelectCompetition = ({ value, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: CompetitionResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.competitionId }));

  return (
    <InfinitySelect<CompetitionResponse>
      {...props}
      url={`${sport}/o/${organizationId}/competitions`}
      sortByFieldName="nameLocal"
      searchParameter="nameLocalContains"
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.COMPETITION}
      permissionOperation={PermissionOperations.READ}
    />
  );
};

export default SelectCompetition;
